/**
 * Custom Nuance Theme JavaScript
 * Accordion behavior for header submenus + Add to Cart Modal + Language Switcher
 */

document.addEventListener('DOMContentLoaded', function() {
  // ===========================================
  // FIX BRAND NAMES IN NAVIGATION
  // ===========================================
  document.querySelectorAll('.header__menu-item, .list-menu__item a, .header__submenu a, .mega-menu a').forEach(function(link) {
    if (link.textContent.trim() === 'ShovHuus') {
      link.textContent = 'Skovhuus';
    }
  });

  // ===========================================
  // AUTO LANGUAGE TRANSLATION FOR STATIC TEXT
  // ===========================================
  initLanguageSwitcher();

  // Accordion behavior - only one submenu open at a time
  const headerSubmenus = document.querySelectorAll('.header__submenu details, .header__menu-item details');

  headerSubmenus.forEach(function(details) {
    details.addEventListener('toggle', function() {
      if (this.open) {
        headerSubmenus.forEach(function(otherDetails) {
          if (otherDetails !== details && otherDetails.open) {
            otherDetails.removeAttribute('open');
          }
        });
      }
    });
  });

  // Also handle nested submenus
  const nestedSubmenus = document.querySelectorAll('.header__submenu .header__submenu details');

  nestedSubmenus.forEach(function(details) {
    details.addEventListener('toggle', function() {
      if (this.open) {
        nestedSubmenus.forEach(function(otherDetails) {
          if (otherDetails !== details && otherDetails.open) {
            otherDetails.removeAttribute('open');
          }
        });
      }
    });
  });

  // ===========================================
  // ADD TO CART MODAL
  // ===========================================

  initAddToCartModal();
});

function initAddToCartModal() {
  // Create modal container if not exists
  if (!document.getElementById('add-cart-modal')) {
    const modalHTML = `
      <div id="add-cart-modal" class="add-cart-modal">
        <div class="add-cart-modal__overlay"></div>
        <div class="add-cart-modal__container">
          <button type="button" class="add-cart-modal__close" aria-label="Fermer">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
          <div class="add-cart-modal__content">
            <div class="add-cart-modal__loading">
              <div class="loading-spinner"></div>
            </div>
          </div>
        </div>
      </div>
    `;
    document.body.insertAdjacentHTML('beforeend', modalHTML);
  }

  const modal = document.getElementById('add-cart-modal');
  const modalContent = modal.querySelector('.add-cart-modal__content');
  const closeBtn = modal.querySelector('.add-cart-modal__close');
  const overlay = modal.querySelector('.add-cart-modal__overlay');

  // Event listeners for buttons - DISABLED
  // document.addEventListener('click', function(e) {
  //   const btn = e.target.closest('.quick-add-modal-btn');
  //   if (btn && !btn.disabled) {
  //     e.preventDefault();
  //     const handle = btn.dataset.productHandle;
  //     openAddCartModal(handle);
  //   }
  // });

  // Close modal
  closeBtn.addEventListener('click', closeAddCartModal);
  overlay.addEventListener('click', closeAddCartModal);
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) {
      closeAddCartModal();
    }
  });

  function openAddCartModal(handle) {
    modal.classList.add('is-open');
    document.body.classList.add('overflow-hidden');
    modalContent.innerHTML = '<div class="add-cart-modal__loading"><div class="loading-spinner"></div></div>';

    // Fetch product data
    fetch(`/products/${handle}.js`)
      .then(res => res.json())
      .then(product => {
        renderModalContent(product);
      })
      .catch(err => {
        modalContent.innerHTML = '<div class="add-cart-modal__loading"><p>Erreur de chargement</p></div>';
      });
  }

  function closeAddCartModal() {
    modal.classList.remove('is-open');
    document.body.classList.remove('overflow-hidden');
  }

  function renderModalContent(product) {
    const hasVariants = product.variants.length > 1;
    const firstVariant = product.variants.find(v => v.available) || product.variants[0];

    // Build options HTML
    let optionsHTML = '';
    if (hasVariants && product.options.length > 0) {
      product.options.forEach((option, optIndex) => {
        const optionValues = [];
        product.variants.forEach(v => {
          const val = v.options[optIndex];
          if (!optionValues.includes(val)) {
            optionValues.push(val);
          }
        });

        optionsHTML += `
          <div class="add-cart-modal__option" data-option-index="${optIndex}">
            <span class="add-cart-modal__option-label">${option}</span>
            <div class="add-cart-modal__option-values">
              ${optionValues.map((val, i) => `
                <label class="add-cart-modal__option-value">
                  <input type="radio" name="option${optIndex}" value="${val}" ${i === 0 ? 'checked' : ''}>
                  <span>${val}</span>
                </label>
              `).join('')}
            </div>
          </div>
        `;
      });
    }

    // Price formatting
    const formatMoney = (cents) => {
      return (cents / 100).toFixed(2).replace('.', ',') + ' $';
    };

    const priceHTML = firstVariant.compare_at_price && firstVariant.compare_at_price > firstVariant.price
      ? `<span class="add-cart-modal__price-current">${formatMoney(firstVariant.price)}</span>
         <span class="add-cart-modal__price-compare">${formatMoney(firstVariant.compare_at_price)}</span>`
      : `<span class="add-cart-modal__price-current">${formatMoney(firstVariant.price)}</span>`;

    // Description (strip HTML and limit)
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = product.description;
    const descText = tempDiv.textContent || tempDiv.innerText || '';
    const shortDesc = descText.length > 250 ? descText.substring(0, 250) + '...' : descText;

    // Helper to get sized image URL
    const getSizedImageUrl = (url, size) => {
      if (!url) return '';
      // Remove any existing size suffix and add new one
      return url.replace(/(_\d+x\d+)?(\.[^.]+)(\?.*)?$/, `_${size}$2$3`);
    };

    // Build thumbnails HTML
    let thumbnailsHTML = '';
    if (product.images && product.images.length > 1) {
      thumbnailsHTML = `
        <div class="add-cart-modal__thumbnails">
          ${product.images.map((img, i) => `
            <button type="button" class="add-cart-modal__thumbnail ${i === 0 ? 'is-active' : ''}" data-image-src="${getSizedImageUrl(img, '600x600')}">
              <img src="${getSizedImageUrl(img, '100x100')}" alt="Image ${i + 1}" loading="lazy">
            </button>
          `).join('')}
        </div>
      `;
    }

    // Get main image URL (first image is always the front-facing one)
    const frontImage = product.images && product.images.length > 0 ? product.images[0] : '';
    const mainImageUrl = frontImage ? getSizedImageUrl(frontImage, '800x800') : '';

    modalContent.innerHTML = `
      <div class="add-cart-modal__image-section">
        <div class="add-cart-modal__image">
          <img src="${mainImageUrl}" alt="${product.title}" id="modal-main-image">
        </div>
        ${thumbnailsHTML}
      </div>
      <div class="add-cart-modal__info">
        <h2 class="add-cart-modal__title">${product.title}</h2>
        <div class="add-cart-modal__price" data-variant-id="${firstVariant.id}">
          ${priceHTML}
        </div>
        ${shortDesc ? `<div class="add-cart-modal__description">${shortDesc}</div>` : ''}

        <div class="add-cart-modal__variants">
          ${optionsHTML}
        </div>

        <div class="add-cart-modal__quantity">
          <span class="add-cart-modal__quantity-label">Quantité</span>
          <div class="add-cart-modal__quantity-selector">
            <button type="button" class="add-cart-modal__qty-btn" data-action="minus">−</button>
            <input type="number" class="add-cart-modal__qty-input" value="1" min="1" max="99">
            <button type="button" class="add-cart-modal__qty-btn" data-action="plus">+</button>
          </div>
        </div>

        <button type="button" class="add-cart-modal__submit" data-variant-id="${firstVariant.id}" ${!firstVariant.available ? 'disabled' : ''}>
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <circle cx="9" cy="21" r="1"></circle>
            <circle cx="20" cy="21" r="1"></circle>
            <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
          </svg>
          ${firstVariant.available ? 'Ajouter au panier' : 'Épuisé'}
        </button>
      </div>
    `;

    // Thumbnail click handlers
    const thumbnails = modalContent.querySelectorAll('.add-cart-modal__thumbnail');
    const mainImage = modalContent.querySelector('#modal-main-image');

    thumbnails.forEach(thumb => {
      thumb.addEventListener('click', () => {
        thumbnails.forEach(t => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
        mainImage.src = thumb.dataset.imageSrc;
      });
    });

    // Store product data for variant selection
    modalContent.productData = product;

    // Quantity buttons
    const qtyInput = modalContent.querySelector('.add-cart-modal__qty-input');
    const qtyBtns = modalContent.querySelectorAll('.add-cart-modal__qty-btn');

    qtyBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        let val = parseInt(qtyInput.value) || 1;
        if (btn.dataset.action === 'minus' && val > 1) {
          qtyInput.value = val - 1;
        } else if (btn.dataset.action === 'plus' && val < 99) {
          qtyInput.value = val + 1;
        }
      });
    });

    // Variant selection
    const optionInputs = modalContent.querySelectorAll('.add-cart-modal__option input');
    optionInputs.forEach(input => {
      input.addEventListener('change', () => updateSelectedVariant(product));
    });

    // Add to cart button
    const submitBtn = modalContent.querySelector('.add-cart-modal__submit');
    submitBtn.addEventListener('click', () => {
      const variantId = submitBtn.dataset.variantId;
      const quantity = parseInt(qtyInput.value) || 1;
      addToCart(variantId, quantity, submitBtn);
    });
  }

  function updateSelectedVariant(product) {
    const selectedOptions = [];
    const optionInputs = modalContent.querySelectorAll('.add-cart-modal__option');

    optionInputs.forEach(optionDiv => {
      const checked = optionDiv.querySelector('input:checked');
      if (checked) {
        selectedOptions.push(checked.value);
      }
    });

    // Find matching variant
    const variant = product.variants.find(v => {
      return selectedOptions.every((opt, i) => v.options[i] === opt);
    });

    if (variant) {
      const submitBtn = modalContent.querySelector('.add-cart-modal__submit');
      const priceDiv = modalContent.querySelector('.add-cart-modal__price');

      submitBtn.dataset.variantId = variant.id;

      if (variant.available) {
        submitBtn.disabled = false;
        submitBtn.innerHTML = `
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <circle cx="9" cy="21" r="1"></circle>
            <circle cx="20" cy="21" r="1"></circle>
            <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
          </svg>
          Ajouter au panier
        `;
      } else {
        submitBtn.disabled = true;
        submitBtn.innerHTML = 'Épuisé';
      }

      // Update price
      const formatMoney = (cents) => (cents / 100).toFixed(2).replace('.', ',') + ' $';
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        priceDiv.innerHTML = `
          <span class="add-cart-modal__price-current">${formatMoney(variant.price)}</span>
          <span class="add-cart-modal__price-compare">${formatMoney(variant.compare_at_price)}</span>
        `;
      } else {
        priceDiv.innerHTML = `<span class="add-cart-modal__price-current">${formatMoney(variant.price)}</span>`;
      }
    }
  }

  function addToCart(variantId, quantity, btn) {
    btn.classList.add('is-loading');
    btn.innerHTML = '<div class="loading-spinner loading-spinner--small"></div> Ajout en cours...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: variantId,
        quantity: quantity
      })
    })
    .then(res => res.json())
    .then(data => {
      btn.classList.remove('is-loading');
      btn.classList.add('is-success');
      btn.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <polyline points="20 6 9 17 4 12"></polyline>
        </svg>
        Ajouté au panier !
      `;

      // Update cart count
      fetch('/cart.js')
        .then(res => res.json())
        .then(cart => {
          const cartCount = document.querySelector('.cart-count-bubble span[aria-hidden="true"]');
          if (cartCount) {
            cartCount.textContent = cart.item_count;
          }
          // Try to update other cart count elements
          document.querySelectorAll('[data-cart-count]').forEach(el => {
            el.textContent = cart.item_count;
          });
        });

      // Close modal after delay
      setTimeout(() => {
        closeAddCartModal();
        btn.classList.remove('is-success');
        btn.innerHTML = `
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <circle cx="9" cy="21" r="1"></circle>
            <circle cx="20" cy="21" r="1"></circle>
            <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
          </svg>
          Ajouter au panier
        `;
      }, 1500);
    })
    .catch(err => {
      btn.classList.remove('is-loading');
      btn.innerHTML = 'Erreur - Réessayer';
      setTimeout(() => {
        btn.innerHTML = `
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <circle cx="9" cy="21" r="1"></circle>
            <circle cx="20" cy="21" r="1"></circle>
            <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
          </svg>
          Ajouter au panier
        `;
      }, 2000);
    });
  }
}

// ===========================================
// LANGUAGE SWITCHER FOR STATIC CONTENT
// ===========================================
function initLanguageSwitcher() {
  // Detect current language from HTML lang attribute or URL
  const htmlLang = document.documentElement.lang || 'fr';
  const isEnglish = htmlLang.toLowerCase().startsWith('en') || window.location.pathname.startsWith('/en');

  // Translation dictionary
  const translations = {
    // Header announcement
    'Livraison gratuite dès 100 $ (avant taxes) | Partout au Canada – Commandez en ligne!': 'Free shipping on orders over $100 (before taxes) | Across Canada – Order online!',

    // Product page sections
    'Livraison gratuite': 'Free Shipping',
    'Livraison gratuite partout au Canada pour les commandes de 100$ et plus (avant taxes).': 'Free shipping across Canada on orders of $100 or more (before taxes).',
    'Échanges faciles': 'Easy Exchanges',
    'Échanges et retours acceptés dans les 14 jours suivant la réception de votre commande.': 'Exchanges and returns accepted within 14 days of receiving your order.',
    'Vous aimerez aussi': 'You may also like',

    // Footer sections
    'Liens rapides': 'Quick Links',
    'Notre mission': 'Our Mission',
    'Inscrivez-vous à notre infolettre': 'Subscribe to our newsletter',

    // Navigation
    'Welcome': 'Home',

    // Hero section
    'Automne Hiver 2025-2026': 'Fall Winter 2025-2026',
    'Découvrez notre nouvelle collection': 'Discover our new collection',
    'Decouvrez notre nouvelle collection': 'Discover our new collection',

    // Product page - Shipping & Returns
    'Livraison & Retours': 'Shipping & Returns',
    'Retours et échanges acceptés dans les 14 jours suivant la réception de votre commande.': 'Returns and exchanges accepted within 14 days of receiving your order.',
    'Voir la politique complète →': 'View full policy →',

    // Hero buttons
    'Voir la collection': 'Shop the collection',

    // Navigation buttons
    'Retour': 'Back'
  };

  // Function to translate elements
  function translateElements(container) {
    const elementsToCheck = container.querySelectorAll('h1, h2, h3, h4, h5, h6, p, span, a, label, button, .footer__content-top h2, .multicolumn-card__info h3, .related-products__heading');

    elementsToCheck.forEach(function(el) {
      const text = el.textContent.trim();

      // Only replace textContent if element has no child elements (to preserve links)
      if (translations[text] && el.children.length === 0) {
        el.textContent = translations[text];
      }

      // For elements with children, use innerHTML replacement to preserve HTML structure
      if (el.children.length > 0) {
        let innerHTML = el.innerHTML;
        Object.keys(translations).forEach(function(frText) {
          if (innerHTML.includes(frText)) {
            innerHTML = innerHTML.replace(new RegExp(frText.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g'), translations[frText]);
          }
        });
        el.innerHTML = innerHTML;
      }
    });
  }

  // If English, swap French text to English
  if (isEnglish) {
    // Translate initial content
    translateElements(document);

    // Watch for dynamically loaded content (like related products)
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) {
            translateElements(node);
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    // Fallback: re-translate after delays for lazy-loaded content
    setTimeout(function() { translateElements(document); }, 500);
    setTimeout(function() { translateElements(document); }, 1500);
    setTimeout(function() { translateElements(document); }, 3000);
  }
}
